<template>
  <bootstrap-modal
    class="modal"
    size="lg"
    @modal-close="$emit('modal-close')"
  >
    <div
      slot="header"
      class="modal-header sleeve-patch-selection-modal__modal-header"
    >
      <button
        type="button"
        class="close modal__close-button sleeve-patch-selection-modal__close-button"
        data-dismiss="modal"
        aria-label="Close"
        @click="$emit('modal-close')"
      >
        <span aria-hidden="true">×</span>
      </button>
      <h4
        class="modal-title sleeve-patch-selection-modal__title"
      >
        Choose Your Patch
      </h4>
    </div>
    <div
      slot="body"
      class="modal-body sleeve-patch-selection-modal__modal-body"
    >
      <patch-group-nav
        v-if="groupsWithPatches.length > 1"
        :patch-groups="groupsWithPatches"
        @patchg-group-clicked="scrollToPatchGroup"
      />
      <div
        id="sleeve-patch-groups"
        class="sleeve-patch-selection-modal__patch-groups"
      >
        <patch-group-listing
          v-for="groupWithPatches in groupsWithPatches"
          :key="groupWithPatches.Id"
          :patch-group="groupWithPatches"
          :patch-group-element-id="getPatchGroupElementId(groupWithPatches.Id)"
          :selected-patch="selectedPatch"
          @patch-selected="handlePatchSelected"
        />
      </div>
      <div
        slot="footer"
        class="modal-footer sleeve-patch-selection-modal__footer"
      />
    </div>
  </bootstrap-modal>
</template>

<script>
import BootstrapModal from '@Shared/components/BootstrapModal.vue'
import PatchGroupNav from './PatchGroupNav'
import PatchGroupListing from './PatchGroupListing'

export default {
  name: 'SleevePatchSelectionModal',
  components: {
    BootstrapModal,
    PatchGroupNav,
    PatchGroupListing
  },
  props: {
    groupsWithPatches: { type: Array, default: function () { return [] }, reuqired: true },
    showModal: { type: Boolean, default: false, required: true }
  },
  computed: {
    content () {
      return this.$store.state.letterJackets.letterJacketContent.catalogContent
    },
    selectedPatch () {
      return this.$store.state.letterJackets.selectedPatch
    }
  },
  watch: {
    showModal (v, ov) {
      if (v === true && this.selectedPatch !== null) {
        this.$nextTick(() => this.scrollToPatchGroup(this.selectedPatch.Group.Id))
      }
    }
  },
  methods: {
    getPatchGroupElementId (patchGroupId) {
      return `sleeve-patch-group-${patchGroupId}`
    },
    scrollToPatchGroup (patchGroupId) {
      this.$scrollTo(`#${this.getPatchGroupElementId(patchGroupId)}`, { container: '#sleeve-patch-groups' })
    },
    handlePatchSelected (patch) {
      this.$emit('patch-selected', patch)
    }
  }
}
</script>

<style lang="scss" scoped>
.sleeve-patch-selection-modal {
  &__modal-header {
    border-bottom: none;
  }

  &__modal-body {
    padding: 0;
  }

  &__title {
    font-size: 36px;
    font-weight: 600;
  }

  &__close-button {
    margin-top: 12px;
  }

  &__patch-groups {
    padding: 0 40px 20px 40px;
    max-height: 560px; // allows two rows of patches to show before scrollbars appear
    overflow-x: hidden;
    overflow-y: auto;
  }

  &__footer {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/letter-jackets/catalog-details/components/SleevePatchSelection/SleevePatchSelectionModal/SleevePatchSelectionModal.vue